import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { AppProviders } from "@/components/providers";
import { AppRouter } from "./router";

import "@/src/globals.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <AppProviders>
      <AppRouter />
    </AppProviders>
  </StrictMode>,
);
